<ng-container *ifScreenSize="screenType.Desktop">
  <div
    class="dropdown"
    [ngClass]="{
      'scorecard-description-share-div': shareType == 'scorecards',
    }"
  >
    <button
      class="btn dropdown-toggle border-0"
      [ngClass]="{
        'd-flex scorecard-description-share': shareType == 'scorecards',
        'btn-muted loyalty-share px-0 rounded-circle': shareType == 'rewards',
      }"
      type="button"
      data-bs-toggle="dropdown"
      aria-expanded="false"
    >
      <span class="material-icons share-icon">share</span>
      <span *ngIf="shareType == 'scorecards'" class="share-text">{{ 'fgbcl.scorecard.description.share' | translate }}</span>
    </button>
    <ul class="dropdown-menu social-share-dropdown-list p-3">
      <li class="social-share-dropdown-list-item mb-3" (click)="shareLink(providerName.Dummy)">
        <span class="d-flex">
          <span class="social-share-icon material-icons icon me-3">content_copy</span>
          <span class="social-share-dropdown-list-item-text"> {{ 'fgbcl.social.share.copy.link' | translate }} </span>
        </span>
      </li>
      <li class="social-share-dropdown-list-item mb-3" (click)="shareLink(providerName.Facebook)">
        <span class="d-flex">
          <img class="social-share-icon me-3" src="assets/images/icons/facebook.svg" />
          <span class="social-share-dropdown-list-item-text"> {{ 'fgbcl.social.share.share.to.facebook.link' | translate }} </span>
        </span>
      </li>
      <li class="social-share-dropdown-list-item" (click)="shareLink(providerName.Twitter)">
        <span class="d-flex">
          <img class="social-share-icon me-3" src="assets/images/icons/twitter.svg" />
          <span class="social-share-dropdown-list-item-text"> {{ 'fgbcl.social.share.share.to.twitter.link' | translate }} </span>
        </span>
      </li>
    </ul>
  </div>
</ng-container>

<ng-container *ifScreenSize="screenType.Mobile">
  <div
    [ngClass]="{
      'scorecard-description-share': shareType == 'scorecards',
      'bg-muted loyalty-share border-0 px-0 rounded-circle': shareType == 'rewards',
    }"
    (click)="shareItem()"
  >
    <span class="material-icons share-icon">share</span>
    <span *ngIf="shareType == 'scorecards'" class="share-text">{{ 'fgbcl.scorecard.description.share' | translate }}</span>
  </div>
</ng-container>
